module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael J. Curley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_c('B', [_vm._v("Michael J. Curley")]), _vm._v(" is professor emeritus of English at the University of Puget Sound. He is the author of many books, including "), _c('I', [_vm._v("Alessandro Manzoni: Two Plays")]), _vm._v(".")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MUjWF/tc-custom/9780226128719.jpg?1731160444284",
      "alt": "This image is the cover for the book Physiologus"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Physiologus\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("One of the most popular and widely read books of the Middle Ages, "), _c('i', [_vm._v("Physiologus")]), _vm._v(" contains allegories of beasts, stones, and trees both real and imaginary, infused by their anonymous author with the spirit of Christian moral and mystical teaching.  Accompanied by an introduction that explains the origins, history, and literary value of this curious text, this volume also reproduces twenty woodcuts from the 1587 version. Originally composed in the fourth century in Greek, and translated into dozens of versions through the centuries, "), _c('i', [_vm._v("Physiologus")]), _vm._v(" will delight readers with its ancient tales of ant-lions, centaurs, and hedgehogs—and their allegorical significance."), _c('br'), _c('br'), _vm._v(" “An elegant little book . . . still diverting to look at today. . . . The woodcuts reproduced from the 1587 Rome edition are alone worth the price of the book.”—Raymond A. Sokolov, "), _c('i', [_vm._v("New York Times Book Review")])]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0